import { render, staticRenderFns } from "./Ip.vue?vue&type=template&id=2a8e72a2&scoped=true"
import script from "./Ip.vue?vue&type=script&lang=js"
export * from "./Ip.vue?vue&type=script&lang=js"
import style0 from "./Ip.vue?vue&type=style&index=0&id=2a8e72a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8e72a2",
  null
  
)

export default component.exports